import { render, staticRenderFns } from "./RoundupsTile.vue?vue&type=template&id=6d1a2a24&"
import script from "./RoundupsTile.vue?vue&type=script&lang=js&"
export * from "./RoundupsTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports